import { useEffect, useState } from 'react'
import { Spinner } from './Spinner'
import { useWindowDimensions } from '../hooks/useWindowDimensions'
// import { WebWorker } from '../workers/worker'
import { useAccountContext } from '../contexts'
import { Devices } from '../common/enums'
import { isPhone } from '../common/constants'

interface Props {
  selectedDevice: string
  setSelectedDevice: (sigfoxId: string) => void
}

export function DeviceSelector({ selectedDevice, setSelectedDevice }: Props) {
  const { height } = useWindowDimensions()
  const { devices } = useAccountContext()

  const [sortBy, setSortBy] = useState({
    target: 'name',
    order: 'asc',
  })

  const [sortedDevices, setSortedDevices] = useState<Devices>(devices)

  // Web Worker Code
  // const [worker] = useState(() => new WebWorker())
  // useEffect(() => {
  //   worker.registerCallback('test', (data) => {
  //     console.log('Worker callback ---->', data)
  //   })
  // }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (devices !== undefined) {
      const sortedDevices = Object.values(devices).sort((a, b) => {
        if (sortBy.target === 'name') {
          return sortBy.order === 'asc'
            ? a.deviceName.localeCompare(b.deviceName)
            : b.deviceName.localeCompare(a.deviceName)
        } else if (sortBy.target === 'site') {
          return sortBy.order === 'asc' ? a.siteName?.localeCompare(b.siteName) : b.siteName?.localeCompare(a.siteName)
        }
        return 0
      })

      const newDevices = sortedDevices.reduce((acc, device) => {
        acc[device.sigfoxId] = device
        return acc
      }, {} as Devices)

      setSortedDevices(newDevices)
    }
  }, [devices, sortBy])

  const showHeader = false
  const username = 'Calgary Tester'
  const accountId = 'YYC-001'

  const deviceListHeight = height - (isPhone ? 60 : 130)

  return (
    <div>
      {showHeader && (
        <>
          <div className="flex flex-row h-8">
            <div className="font-bold basis-1/2" style={styles.column}>
              User Name:
            </div>
            <div className="font-bold basis-1/2" style={styles.column}>
              {username}
            </div>
          </div>
          <div className="flex flex-row h-8">
            <div className="basis-1/2 bold-font" style={styles.column}>
              Account ID:
            </div>
            <div className="basis-1/2" style={styles.column}>
              {accountId}
            </div>
          </div>
        </>
      )}
      <div className="overflow-y-auto" style={{ height: deviceListHeight }}>
        <table>
          <thead>
            <tr className="h-8 bg-gray-100 border-y-2 border-x-gray-400">
              <th
                className="pl-3"
                style={styles.column}
                onClick={() =>
                  setSortBy({
                    target: 'name',
                    order: sortBy.order === 'asc' ? 'desc' : 'asc',
                  })
                }
              >
                Name
              </th>
              <th
                className="pl-3"
                style={styles.column}
                onClick={() =>
                  setSortBy({
                    target: 'site',
                    order: sortBy.order === 'asc' ? 'desc' : 'asc',
                  })
                }
              >
                Site
              </th>
            </tr>
          </thead>
          <tbody>
            {devices !== undefined
              ? Object.values(sortedDevices).map((device) => (
                  <tr
                    key={device.sigfoxId}
                    className={`border-y-2 border-x-gray-400 h-10 ${
                      device.sigfoxId === selectedDevice ? 'bg-blue-50' : ''
                    }`}
                    onClick={() => setSelectedDevice(device.sigfoxId)}
                  >
                    <td className="pl-2 cursor-pointer" width={120}>
                      <div>{device.deviceName || <Spinner size={15} />}</div>
                    </td>
                    <td className="pl-2 cursor-pointer" width={120}>
                      {device.siteName || '-'}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const styles = {
  column: { minWidth: '120px' },
}
